import { useEffect, useState } from "react";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";

const useAndamentoDesignaDocumento = () => {
  const [docDesignaParams, setDocDesignaParams] = useState({
    sqOrdemServico: null,
    nuInscricaoEstadual: null,
    sqAcaoFiscal: null,
  });
  const { request: requestDocumento, data: dataDocumento } = useApiClient();

  useEffect(() => {
    if (docDesignaParams?.sqAcaoFiscal) {
      const values = docDesignaParams;
      requestDocumento(apiRoutes.fiscalizacao.ordemservico.documentoAndamentoOs, values);
    }
  }, [requestDocumento, docDesignaParams]);

  useEffect(() => {
    let win;
    if (dataDocumento?.result) {
      win = window.open("", "", "height=800, width=800");
      win.document.write(dataDocumento.result);
      win.document.close();
      win.setTimeout(win.print, 1000);
    }
  }, [dataDocumento]);

  const documentoPrint = () => {};

  return { documentoPrint, setDocDesignaParams };
};

export default useAndamentoDesignaDocumento;
